import { put, select } from "redux-saga/effects";
import moment from "moment";
import * as GlobalActions from "../actions";
import { msalConfig } from "../config/msal/authConfig";
import { store } from '../index';

export const getViewport = () => {
  const element = window;
  const dimension = {
    width: element.innerWidth,
    height: element.innerHeight
  };
  return dimension;
};

function getTokenNew() {
  const state = store.getState();
  const token = state.stateToken || '';
  return token;
}

export function handleErrors(response) {
  // handle for guest user and propmt for login
  if (response.status === 401) {
    // const url = `${window.location.origin}/login`;
    // window.location = url;
    // const noError = {};
    const error = {
      error: {
        code: response.status,
        message: response.statusText
      },
      status: response.status,
      statusText: response.statusText,
      type: "AuthError"
    };
    return Promise.reject(error);
  }
  if (response.status >= 500) {
    const error = {
      error: {
        code: response.status,
        message: response.statusText
      },
      status: response.status,
      statusText: response.statusText
    };
    return Promise.reject(error);
  }
  // normal response handling
  return response.json().then(json => {
    if (!response.ok) {
      const error = Object.assign({}, json, {
        status: response.status,
        statusText: response.statusText
      });
      return Promise.reject(error);
    }
    return json;
  });
}

export function showMessage(message, info) {
  message.info(info);
}

export const getPostParams = payload => ({
  method: "POST",
  headers: {
    Authorization: `Bearer ${getTokenNew()}`,
    "Ocp-Apim-Subscription-Key": msalConfig["Ocp-Apim-Subscription-Key"]
  },
  // credentials: 'include',
  body: JSON.stringify(payload)
});

export const getFormDataPostParams = payload => ({
  method: "POST",
  headers: {
    Authorization: `Bearer ${getTokenNew()}`,
    "Ocp-Apim-Subscription-Key": msalConfig["Ocp-Apim-Subscription-Key"]
  },
  body: payload
});

export const getFormDataPutParams = payload => ({
  method: "PUT",
  body: payload
});

export const getFormDataParams = payload => ({
  method: "POST",
  body: payload // formdata
});

export const getGetParams = () => ({
  method: "GET",
  headers: {
    Authorization: `Bearer ${getTokenNew()}`,
    "Ocp-Apim-Subscription-Key": msalConfig["Ocp-Apim-Subscription-Key"]
  }
});

export const getDeleteParams = () => ({
  method: "DELETE",
  headers: {
    Authorization: `Bearer ${getTokenNew()}`,
    "Ocp-Apim-Subscription-Key": msalConfig["Ocp-Apim-Subscription-Key"]
  }
});

export const getPutParams = payload => {
  return {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${getTokenNew()}`,
      "Ocp-Apim-Subscription-Key": msalConfig["Ocp-Apim-Subscription-Key"]
    },
    body: JSON.stringify(payload)
  };
};

export const getPatchParams = payload => ({
  method: "PATCH",
  headers: {
    Authorization: `Bearer ${getTokenNew()}`,
    "Ocp-Apim-Subscription-Key": msalConfig["Ocp-Apim-Subscription-Key"]
  },
  body: JSON.stringify(payload)
});

const handleCatch = err => {
  if (err.toString().indexOf("TypeError") > -1) {
    return {
      error: {
        code: "",
        message: err.toString()
      },
      status: "",
      statusText: ""
    };
  }
  return err;
};

export const Api = {
  fetch: (url, params) => {
    if (!url) { 
      throw new Error("Uh-oh, url not found");
    }
    return fetch(url, params)
      .then(handleErrors)
      .catch(handleCatch);
  }
};

export function* wrapByLoader(fn) {
  yield put(GlobalActions.fetchStart());
  yield fn();
  yield put(GlobalActions.fetchEnd());
}

export function* wrapWithoutLoader(fn) {
  yield fn();
}

/**
 * A utility function to type check if Map object .get method returns
 * valid value else thro an error
 * @param {Object} map - An ES6 Map() Object
 * @param {string} key - A key of Map() Object.
 */
export function getOrThrow(map, key) {
  const val = map.get(key);
  if (val == null) {
    throw new Error("Uh-oh, key not found");
  }
  return val;
}

export function getFormattedDate(date, dateFormat) {
  return moment(date).format(dateFormat);
}

export function getCustomerType(type) {
  return type ? "Customer" : "Prospect";
}

// check for number with 2 digit decimal
export const isNumeric = value => {
  const numRegExPattern =
    "^\\s*((\\d+(\\.\\d{0,2})?)|((\\d*(\\.\\d{1,2}))))\\s*$";
  const numRegExre = new RegExp(numRegExPattern);
  return numRegExre.test(value);
};
// check for number with 2 digit decimal
export const isInteger = value => {
  const numRegExre = new RegExp(/^[0-9]\d*$/);
  return numRegExre.test(value);
};
export const filterUser = (user, val) => {
  const value = val.toLowerCase();
  const userName = user.text.toLowerCase();
  const initials = userName
    .split(" ")
    .map(name => name[0])
    .join("");
  return (
    userName.includes(value) ||
    user.value.toLowerCase().includes(value) ||
    initials.includes(value)
  );
};

export const changeLogLabelMap = {
  bpName: { title: "BP Name One", width: 200 },
  bpName2: { title: "BP Name Two", width: 150 },
  bpSearchName: { title: "Search Name", width: 200 },
  bpPhoneNr: { title: "Telephone number", width: 150 },
  bpPhoneAreaCode: { title: "Telephone Area Code", width: 200 },
  bpEmail: { title: "Email", width: 200 },
  bpWebsite: { title: "Website", width: 200 },
  role: { title: "BP Role", width: 100 },
  bpStreet: { title: "Street One", width: 200 },
  bpHouseNr: { title: "House number", width: 120 },
  bpCountryRef: { title: "Country", width: 100 },
  bpStateProvinceRef: { title: "State province", width: 120 },
  bpCityRef: { title: "City", width: 100 },
  bpPostalcodeRef: { title: "Postal Code", width: 120 },
  bpPobox: { title: "Post Office Box", width: 140 },
  bpPoboxZipcode: { title: "PO Box Zip Code", width: 140 },
  bpPoboxCityRef: { title: "PO Box City", width: 100 },
  bankName: { title: "Bank Name", width: 100 },
  bankAccountNumber: { title: "Bank Acc. No.", width: 120 },
  bpYearlyTurnover: { title: "Yearly Turnover", width: 130 },
  bpChamberOfCommerceNr: { title: "Chamber of commerce", width: 180 },
  bpDuns: { title: "Duns No.", width: 100 },
  bpCurrencyRef: { title: "Currency", width: 100 },
  taxNumber: { title: "VIES Number", width: 100 },
  tnVIESNumber: { title: "VIES Number", width: 100 },
  viesCountry: { title: "VIES Country", width: 100 },
  intTaxNumber: { title: "Int. Tax (Non-EU Countries)", width: 200 },
  tnLocalTaxNumber: { title: "Local Tax Number", width: 200 },
  intTaxCountry: { title: "Int. Tax(Non-EU) Country", width: 200 },
  tnIntTaxNumber: { title: "Int. Tax(Non-EU) Country", width: 200 },
  tnVIESNumberCountryRef: { title: "VIES Number Country Ref.", width: 200 },
  tnIntTaxNumberCountryRef: { title: "Tax Number Country Ref.", width: 200 },
  nationalVATNumber: { title: "Local Tax/Fiscal ID", width: 200 },
  localTaxCountry: { title: "Local Tax/Fixcal ID Country", width: 200 },

  bpStatus: { title: "Status", width: 100 },
  bpAction: { title: "Action", width: 100 },
  bankCountry: { title: "Bank Country", width: 110 },
  paymentTerms: { title: "Payment Terms", width: 130 },
  bicSwift: { title: "BIC/SWIFT", width: 100 },
  baCountryRef: { title: "Bank Country Ref.", width: 100 },
  comments: { title: "Comments", width: 200 },
  relevantPlants: { title: "Relevant Plant(s) of BP ", width: 200 },
  bpPoboxStateProvinceRef: { title: "PO Box State province", width: 200 },

  baBankBICSWIFT: { title: "BIC/SWIFT", width: 200 },
  baIban: { title: "IBAN", width: 200 },
  bpReleventPlant: { title: "Relevant Plant", width: 200 },
  bpComment: { title: "Comment", width: 200 }
};

export function generateSearchUrlParam(paramObj, noSearch = false) {
  let urlParams = "";
  if (!noSearch) {
    urlParams += `name=${paramObj.searchObj ? paramObj.searchObj.name || "" : ""
      }`;
    urlParams += `&mdmId=${paramObj.searchObj ? paramObj.searchObj.mdmId || "" : ""
      }`;
    urlParams += `&externalId=${paramObj.searchObj ? paramObj.searchObj.externalId || "" : ""
      }`;
    urlParams += `&postalCode=${paramObj.searchObj ? paramObj.searchObj.postalCode || "" : ""
      }`;
    urlParams += `&city=${paramObj.searchObj ? paramObj.searchObj.city || "" : ""
      }`;
    urlParams += `&viesNumber=${paramObj.searchObj ? paramObj.searchObj.viesNumber || "" : ""
      }`;
    urlParams += `&country=${paramObj.searchObj ? paramObj.searchObj.country || "" : ""
      }`;
    urlParams += "&";
  }
  urlParams += `page=${paramObj.page}`;
  urlParams += `&pageSize=${paramObj.pageSize}`;
  urlParams += paramObj.sortBy
    ? `&sort=${paramObj.sortBy} ${paramObj.isSortAscending ? "asc" : "desc"}`
    : "&sort=";

  const filterParams = paramObj.searchData
    .map(field => `${field.dbKey} ${field.value}`)
    .join(",");

  urlParams += `&filter=${filterParams}`;
  return urlParams;
}

export const initialSearchObj = {
  name: "",
  mdmId: null,
  externalId: null,
  city: "",
  postalCode: "",
  viesNumber: "",
  country: null,
  error: false
};

export function getSearchObjFromUrl(query) {
  const urlParams = decodeURI(query)
    .substr(1)
    .split("&")
    .reduce((paramsObj, param) => {
      return { ...paramsObj, [param.split("=")[0]]: param.split("=")[1] };
    }, initialSearchObj);

  // prepare object to hydrate form
  const searchObj = {
    name: urlParams.name || "",
    mdmId: urlParams.mdmId || null,
    externalId: urlParams.externalId || null,
    city: urlParams.city || "",
    postalCode: urlParams.postalCode || "",
    viesNumber: urlParams.viesNumber || "",
    country: +urlParams.country || null
  };
  const sortInfo =
    urlParams.sort && urlParams.sort.split(" ")[0] !== ""
      ? {
        field: urlParams.sort.split(" ")[0] || "",
        order: urlParams.sort.split(" ")[1]
      }
      : null;

  const paginationInfo =
    urlParams.page || urlParams.pageSize
      ? {
        currentPage: urlParams.page || 1,
        pageSize: urlParams.pageSize || 15
      }
      : null;
  const filters = urlParams.filter
    ? urlParams.filter.split(",").reduce((filter, field) => {
      // eslint-disable-next-line no-param-reassign
      filter[field.split(" ")[0]] = [field.split(" ")[1]];
      return filter;
    }, {})
    : null;

  return { searchObj, sortInfo, paginationInfo, filters };
}
